<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="reportsVisible = !reportsVisible">
                  {{ $t('sports.ski_report_title') }} ({{ results.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="reportsVisible = !reportsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:reportsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: reportsVisible }">
            <div class="col-12 d-flex justify-content-end my-2">
              <button class="btn btn-sm btn-outline-success form-button float-right dont-print hidden" :disabled="results.length < 1" @click="exportExcel">
                {{ $t('trip.download_excel') }}
              </button>
            </div>
            <div v-if="resultList && resultList.length > 0" class="col-sm-12 list-content result-table my-2">
                <vue3-datatable
                    :rows="resultList"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="50vh"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                >
                    <template #time="data">
                        {{ data.value.time ? toLocalTime(data.value.time) : '' }}
                    </template>
                    <template #contract="data">
                        {{ data.value.name ? data.value.name : '' }}
                    </template>
                </vue3-datatable>
            </div>
      </div>
      <hr class="report-divider nopads"/>
  </div>
</template>

<script>
import {timeUtils} from "../../mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'SportWorkList',
    components: {Vue3Datatable},
    mixins: [timeUtils, restApi],
    props: {
        params: {
            type: Object,
            default() {
                return null
            }
        },
        showTitle: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            reportsVisible: false,
            results: [],
            resultList: [],
            loading: false,
        }
    },
    computed: {
        fields() {
            return [
                {field: 'time', title: this.$t('areas.time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'track_name', title: this.$t('sports.route'), sort: true, headerClass: 'routa-table-header'},
                {field: 'link_id', title: this.$t('sports.link'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract_name', title: this.$t('areas.work_contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'task_type_name', title: this.$t('areas.work_task'), sort: true, headerClass: 'routa-table-header'},
                {field: 'addition', title: this.$t('areas.addition'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        params() {
            this.fetchWorkRecords()
        },
        results() {
            let temp = []
            this.resultList = []
            this.results.forEach(item => {
                let newItem = item
                newItem.addition = item.added_by ? this.$t('areas.manual_addition') : this.$t('areas.tracking')
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted() {
        this.fetchWorkRecords()
    },
    methods: {
        fetchWorkRecords() {
            this.results = []
            if (this.params) {
                // Clone the params to avoid mutating props
                const apiParams = { ...this.params }

                // Turn single contract to array!
                if (apiParams.contract) {
                    if (apiParams.contracts) {
                        apiParams.contractIds.push(apiParams.contract)
                    } else {
                        apiParams.contractIds = [apiParams.contract]
                    }
                    apiParams.contract = null
                }
                if(apiParams.dateFrom) {
                    apiParams.from = apiParams.dateFrom
                }
                if(apiParams.dateTo) {
                    apiParams.to = apiParams.dateTo
                }
                this.loading = true
                this.restFetchParams(this.skiingTrackWorkUrl, apiParams, this.success, this.fail)
            }
        },

        success: function (response) {
            this.loading = false
            this.results = response.data
        },

        showSkiWork: function (row) {
            if (!this.loading) {
                let selectedItem = this.results.find(item => item.id === row.id)
                if (selectedItem){
                    this.$emit('rowSelected', selectedItem)
                }
            }
        },

        fail: function () {
            this.loading = false
        },

    }
}
</script>

<style scoped>
</style>
